module.exports = __webpack_public_path__ + "static/media/ribbon.bf2c8a6d.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/ribbon.PNG
// module id = 562
// module chunks = 0